import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.observer = new MutationObserver(() => this.sync())
    this.observer.observe(this.element, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-ids"]
    })
    this.sync()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  sync() {
    const pending = this.pendingIds()

    this.element.querySelectorAll("[data-role='invite']").forEach((slot) => {
      const inviteeId = Number(slot.dataset.inviteeId)
      const isPending = pending.includes(inviteeId)

      slot.querySelectorAll("[data-invite-action='create']").forEach((el) => {
        el.classList.toggle("hidden", isPending)
      })
      slot.querySelectorAll("[data-invite-action='cancel']").forEach((el) => {
        el.classList.toggle("hidden", !isPending)
      })
    })
  }

  pendingIds() {
    const el = document.getElementById("pending_invitation_ids")
    if (!el) return []

    try {
      return JSON.parse(el.dataset.ids || "[]").map(Number)
    } catch {
      return []
    }
  }
}
